import React from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  brandColours,
  fontWeights,
  fontSize,
} from '../styles';

const StyledPriceCard = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding: 30px 20px;
  width: 100%;
  text-align: center;
  background-color: ${brandColours.tertiary};
  border-radius: 15px;

  ${({ isBanner }) => {
    if (isBanner) {
      return css`
        ${minBreakpointQuery.tiny`
          width: calc((100% - 20px) / 2);
        `}

        ${minBreakpointQuery.small`
          width: calc((100% - 40px) / 3);
        `}
      `;
    } else {
      return css`
        ${minBreakpointQuery.tiny`
          padding-top: 40px;
          padding-bottom: 40px;
        `}

        ${minBreakpointQuery.tsmall`
          width: calc((100% - 20px) / 2);
        `}

        ${minBreakpointQuery.small`
          padding-top: 50px;
          padding-bottom: 50px;
        `}

        ${minBreakpointQuery.mlarge`
          width: calc((100% - 40px) / 3);
        `}

        ${minBreakpointQuery.large`
          padding-top: 60px;
          padding-bottom: 60px;
        `}

        ${minBreakpointQuery.xxlarge`
          padding-top: 65px;
          padding-bottom: 65px;
        `}
      `;
    }
  }}
`;

const StyledHeading = styled.h3`
  font-weight: ${fontWeights.semibold};
  line-height: 1.1;

  ${({ isBanner }) => {
    if (!isBanner) {
      return css`
        ${fontSize(20)};
      `;
    }
  }}
`;

const StyledPrice = styled.p`
  color: ${brandColours.primary};
  font-weight: ${fontWeights.bold};
  line-height: 1;
  letter-spacing: -1px;

  ${({ isBanner }) => {
    if (isBanner) {
      return css`
        ${fontSize(50)};

        ${minBreakpointQuery.xlarge`
          ${fontSize(54)};
        `}
      `;
    } else {
      return css`
        ${fontSize(58)};

        ${minBreakpointQuery.tsmall`
          ${fontSize(62)};
        `}

        ${minBreakpointQuery.smedium`
          ${fontSize(66)};
        `}

        ${minBreakpointQuery.xlarge`
          ${fontSize(70)};
        `}
      `;
    }
  }}
`;

const StyledText = styled.p`
  line-height: 1.2;

  ${({ isBanner }) => {
    if (!isBanner) {
      return css`
        ${fontSize(20)};
      `;
    }
  }}
`;

const PriceCard = ({ heading, price, text, isBanner, ...props }) => (
  <StyledPriceCard isBanner={isBanner} {...props}>
    <StyledHeading isBanner={isBanner}>{heading}</StyledHeading>
    <StyledPrice isBanner={isBanner}>{price}</StyledPrice>
    <StyledText isBanner={isBanner}>{text}</StyledText>
  </StyledPriceCard>
);

export default PriceCard;
